import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as FileSaver from 'file-saver';
import { ReportService } from '../../services/report.service';
import { ReportDownloadService } from '../../services/report-download.service';
import { RoutingService } from '../../../routing/services/routing.service';
import 'rxjs/Rx';

@Component({
    selector: 'app-report-download',
    templateUrl: './report-download.component.html'
})

export class ReportDownloadComponent {
    constructor(private reportService: ReportService, private routingService: RoutingService,
        private reportDownloadService: ReportDownloadService, private activateRoute: ActivatedRoute) {
        this.handleFileDownload();
    }

    private handleFileDownload() {

        this.reportDownloadService.getDownloadFile(this.activateRoute).subscribe(
            (response) => {
                const fileName = this.reportDownloadService.getFilenameFromResponse(response);
                FileSaver.saveAs(response.body, fileName);
                this.reportService.getLatestReports();
                this.routingService.routeToDashboard();
            },
            (error) => {
                console.log(error);
                this.routingService.routeToDashboard();
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/report/components/download/report-download.component.ts